// Países onde a Stripe processa pagamentos (stripe.com/br/global), sem o
// Brasil — vendas nacionais ficam na aba Brasil da prévia. As bandeiras vêm
// da flagcdn.com por código ISO, como no restante do app (ChargebackDetails).
// Os nomes são resolvidos no render para acompanhar o idioma ativo; o `iso`
// é o código da bandeira e nunca deve ser traduzido.
export const getInternationalCountries = (t) => [
    { name: t("managePlan.checkoutPreview.countries.za"), iso: "za" },
    { name: t("managePlan.checkoutPreview.countries.de"), iso: "de" },
    { name: t("managePlan.checkoutPreview.countries.au"), iso: "au" },
    { name: t("managePlan.checkoutPreview.countries.at"), iso: "at" },
    { name: t("managePlan.checkoutPreview.countries.be"), iso: "be" },
    { name: t("managePlan.checkoutPreview.countries.bg"), iso: "bg" },
    { name: t("managePlan.checkoutPreview.countries.ca"), iso: "ca" },
    { name: t("managePlan.checkoutPreview.countries.cy"), iso: "cy" },
    { name: t("managePlan.checkoutPreview.countries.hr"), iso: "hr" },
    { name: t("managePlan.checkoutPreview.countries.dk"), iso: "dk" },
    { name: t("managePlan.checkoutPreview.countries.ae"), iso: "ae" },
    { name: t("managePlan.checkoutPreview.countries.sk"), iso: "sk" },
    { name: t("managePlan.checkoutPreview.countries.si"), iso: "si" },
    { name: t("managePlan.checkoutPreview.countries.es"), iso: "es" },
    { name: t("managePlan.checkoutPreview.countries.us"), iso: "us" },
    { name: t("managePlan.checkoutPreview.countries.ee"), iso: "ee" },
    { name: t("managePlan.checkoutPreview.countries.fi"), iso: "fi" },
    { name: t("managePlan.checkoutPreview.countries.fr"), iso: "fr" },
    { name: t("managePlan.checkoutPreview.countries.gi"), iso: "gi" },
    { name: t("managePlan.checkoutPreview.countries.gr"), iso: "gr" },
    { name: t("managePlan.checkoutPreview.countries.hk"), iso: "hk" },
    { name: t("managePlan.checkoutPreview.countries.hu"), iso: "hu" },
    { name: t("managePlan.checkoutPreview.countries.ie"), iso: "ie" },
    { name: t("managePlan.checkoutPreview.countries.it"), iso: "it" },
    { name: t("managePlan.checkoutPreview.countries.jp"), iso: "jp" },
    { name: t("managePlan.checkoutPreview.countries.lv"), iso: "lv" },
    { name: t("managePlan.checkoutPreview.countries.li"), iso: "li" },
    { name: t("managePlan.checkoutPreview.countries.lt"), iso: "lt" },
    { name: t("managePlan.checkoutPreview.countries.lu"), iso: "lu" },
    { name: t("managePlan.checkoutPreview.countries.my"), iso: "my" },
    { name: t("managePlan.checkoutPreview.countries.mt"), iso: "mt" },
    { name: t("managePlan.checkoutPreview.countries.mx"), iso: "mx" },
    { name: t("managePlan.checkoutPreview.countries.no"), iso: "no" },
    { name: t("managePlan.checkoutPreview.countries.nz"), iso: "nz" },
    { name: t("managePlan.checkoutPreview.countries.nl"), iso: "nl" },
    { name: t("managePlan.checkoutPreview.countries.pl"), iso: "pl" },
    { name: t("managePlan.checkoutPreview.countries.pt"), iso: "pt" },
    { name: t("managePlan.checkoutPreview.countries.gb"), iso: "gb" },
    { name: t("managePlan.checkoutPreview.countries.cz"), iso: "cz" },
    { name: t("managePlan.checkoutPreview.countries.ro"), iso: "ro" },
    { name: t("managePlan.checkoutPreview.countries.sg"), iso: "sg" },
    { name: t("managePlan.checkoutPreview.countries.se"), iso: "se" },
    { name: t("managePlan.checkoutPreview.countries.ch"), iso: "ch" },
    { name: t("managePlan.checkoutPreview.countries.th"), iso: "th" },
];
